import { useMutation } from "@tanstack/react-query";
import clienteAxios from "../../helpers/clienteAxios";
import { useLoading } from "../../context/loadingContext";
import Swal from "sweetalert2";

const api = async (datos) => {
  const { data } = await clienteAxios.post(
    "/sucursalVirtual/crm/cambio/credencialesRed",
    datos
  );
  return data;
};

const useCambioCredenciales = () => {
  const { setLoading, removeLoading } = useLoading();
  return useMutation(api, {
    onMutate: () => {
      setLoading({
        id: "cambioRed",
        message: "Por favor espere...",
      });
    },
    onSuccess: (response) => {
      removeLoading({ id: "cambioRed" });
    },
    onError: (error) => {
      removeLoading({ id: "cambioRed" });
      Swal.fire({
        icon: "error",
        title: error.response.data.error.detalleRespuesta,
        confirmButtonText: "Volver",
        focusConfirm: false,
        iconColor: "red",
        width: "40rem",
        allowOutsideClick: false,
        customClass: {
          popup: "containerSwal",
          title: "titleSwal",
          closeButton: "...",
          icon: "iconSwal",
          confirmButton: "buttonSwal",
          denyButton: "...",
          cancelButton: "...",
        },
      });
    },
  });
};

export default useCambioCredenciales;
